import { useRouter } from "next/router";
import { useEffect } from "react";
import HeaderTopEight from "./Header-Top/HeaderTop-Eight";
import HeaderOne from "./Headers/Header-One";
import HeaderHr from "./Headers/Header-Hr";
import HeaderEight from "./Headers/Header-Eight";


const HeaderStyleTen = ({ headerSticky }) => {
  const router = useRouter();

  const authRoutes = ["/login", "/register", "/become-a-teacher"];

  const isAuthRoute =
    authRoutes.includes(router.pathname) ||
    router.pathname.startsWith("/login") ||
    router.pathname.startsWith("/register");

  const isHrAdminRoute = router.pathname.startsWith("/hr-admin");

  useEffect(() => {
    if (isAuthRoute) {
    } else if (isHrAdminRoute) {
    } else {
    }
  }, [router.pathname, isAuthRoute, isHrAdminRoute]);



  return (
    <>

      <header className="rbt-header rbt-header-10">

        {isAuthRoute ? (
          <HeaderOne
            headerSticky={headerSticky}
            sticky="header-sticky"
            container="container-fluid"
            gapSpaceBetween="header-space-betwween"
            navigationEnd="rbt-navigation-start"
          />

        ) : isHrAdminRoute ? (
          <HeaderHr
            headerSticky={headerSticky}
            sticky="header-sticky"
            container="container-fluid"
            gapSpaceBetween="header-space-betwween"
            navigationEnd="rbt-navigation-start"
          />
        ) : (
          <>

            <HeaderEight
              headerSticky={headerSticky}
              sticky="header-sticky"
              container="container-fluid"
              gapSpaceBetween="header-space-betwween"
              navigationEnd="rbt-navigation-start"
            />

          </>
        )}
      </header>
    </>
  );
};

export default HeaderStyleTen;